import { SPINNER_STRINGS } from "../data/spinnerStrings";

export const EXISTING_OFFER_TEXT = SPINNER_STRINGS.otp.existingOffer;

export const getWheelSize = () => {
  if (typeof window === "undefined") return 320;
  const viewportWidth = window.innerWidth;
  const contentWidth = viewportWidth < 640 ? viewportWidth - 64 : viewportWidth - 120;

  return Math.max(220, Math.min(420, contentWidth));
};

export const pickMockOffer = (offers) => {
  if (!offers.length) return null;

  const weightedBag = offers.flatMap((offer) => {
    const percentage = Number(offer.percentageOff ?? 0);

    if (percentage >= 15 && percentage <= 35) {
      return Array(18).fill(offer);
    }

    if (percentage >= 100) {
      return [offer];
    }

    if (percentage >= 75) {
      return Array(2).fill(offer);
    }

    if (percentage >= 50) {
      return Array(3).fill(offer);
    }

    if (percentage >= 10) {
      return Array(5).fill(offer);
    }

    return Array(4).fill(offer);
  });

  return weightedBag[Math.floor(Math.random() * weightedBag.length)] ?? offers[0];
};

export const resolveOfferFromSavedValue = ({ offers, savedOffer }) => {
  if (!savedOffer) return null;

  const directMatch = offers.find(
    (offer) =>
      offer.percentageOff === (savedOffer.percentageOff ?? null) &&
      offer.flatOff === (savedOffer.flatOff ?? null)
  );

  if (directMatch) return directMatch;

  if (savedOffer.percentageOff != null) {
    return offers.find((offer) => offer.percentageOff === savedOffer.percentageOff) ?? null;
  }

  return null;
};